import { useState, useRef, useCallback, useEffect } from "react";
import UploadManager from "../components/UploadManager";

/**
 * Custom hook for managing file uploads
 * @returns {Object} File upload state and handlers
 */
export const useFileUpload = () => {
  const uploadManagerRef = useRef(new UploadManager());
  const uploadInputRef = useRef(null);
  const [files, setFiles] = useState([]);

  const handleFileChange = useCallback(async event => {
    const fileArr = [...uploadInputRef.current.files];
    setFiles(fileArr);
    await uploadManagerRef.current.uploadFiles(fileArr);
  }, []);

  const handleFileProgress = useCallback(files => {
    setFiles([...files]);
  }, []);

  useEffect(() => {
    uploadManagerRef.current.addProgressListener(handleFileProgress);

    return () => {
      uploadManagerRef.current.removeProgressListener(handleFileProgress);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    uploadManagerRef,
    uploadInputRef,
    files,
    handleFileChange,
  };
};
